module.exports = __webpack_public_path__ + "images/application/i-navigation-f0e4cfc9.svg";